import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { backend } from '../axios/backend';
import ProductForm from '../components/ProductForm';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import { useAppContext } from '../context/AppContext';
import { parseErrorMessage } from '../utils/error-message';

const NewWishPage = () => {
  const navigate = useNavigate();
  const { alertSuccess, alertError } = useAppContext();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (values: {
      name: string;
      price?: number;
      comment?: string;
      url?: string;
      tags?: string[];
      imageUrl?: string;
    }) => {
      await backend.post('wish/my', values);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('my-wishes');
        alertSuccess('Wunsch hinzugefügt.');
        navigate('/my-wishes');
      },
      onError: (e) => {
        alertError(parseErrorMessage(e));
      },
    },
  );

  return (
    <div style={{ margin: '2rem' }} className="space-y-4">
      <Breadcrumbs
        crumbs={[
          { text: 'Meine Wünsche', route: '/my-wishes' },
          { text: 'Wunsch hinzufügen', route: '/new-wish/' },
        ]}
      />
      <h1 className="text-white text-xl">
        <b>Wunsch hinzufügen</b>
      </h1>
      <ProductForm
        onSubmit={mutation.mutate}
        isLoading={mutation.isLoading}
        submitText="Wunsch hinzufügen"
        type="wish"
      />
    </div>
  );
};

export default NewWishPage;
